import { MOLAR } from 'constants/prescriptionConstants';
import {
  RESOLVE_CROWDING_OPTION,
  RESOLVE_CROWDING_OPTION_LOWER,
  RESOLVE_CROWDING_OPTION_UPPER,
  SAGITTAL_IMPROVE_SUBOPTIONS
} from 'constants/prescriptionOptions';

export const getResolveCrowdingConfig = (isLower: boolean) => {
  return [
    {
      key: 'archExpansion',
      name: 'crowding.arch_expansion',
      options: RESOLVE_CROWDING_OPTION
    },
    {
      key: 'proclination',
      name: 'crowding.proclination',
      options: RESOLVE_CROWDING_OPTION
    },
    {
      key: 'ipr',
      name: 'crowding.ipr',
      options: RESOLVE_CROWDING_OPTION,
      subOptions: [
        {
          key: 'anteriorTeeth',
          name: 'crowding.anterior_teeth',
          options: RESOLVE_CROWDING_OPTION
        },
        {
          key: 'rightPosteriorTeeth',
          name: 'crowding.right_posterior_teeth',
          options: RESOLVE_CROWDING_OPTION
        },
        {
          key: 'leftPosteriorTeeth',
          name: 'crowding.left_posterior_teeth',
          options: RESOLVE_CROWDING_OPTION
        }
      ]
    },
    {
      key: 'molarDistalization',
      name: 'crowding.molar_distalization',
      options: isLower
        ? RESOLVE_CROWDING_OPTION_LOWER
        : RESOLVE_CROWDING_OPTION_UPPER,
      isMultiCheck: true
    }
  ];
};
export const getSagittalImproveSubOptionsConfig = (improvementType: string) => {
  return [
    {
      key: 'ipr',
      name: 'crowding.ipr',
      options: SAGITTAL_IMPROVE_SUBOPTIONS
    },
    {
      key: 'elastic',
      name: 'sagittal_relationship.class_ii_iii_elastic',
      options: SAGITTAL_IMPROVE_SUBOPTIONS
    },
    {
      key:
        improvementType === MOLAR
          ? 'molarDistalization'
          : 'canineDistalization',
      name:
        improvementType === MOLAR
          ? 'crowding.molar_distalization'
          : 'crowding.canine_distalization',
      options: SAGITTAL_IMPROVE_SUBOPTIONS
    },
    {
      key: 'associatedElastic',
      name: 'sagittal_relationship.mia_tad_associated_elastic',
      options: SAGITTAL_IMPROVE_SUBOPTIONS
    },
    {
      key:
        improvementType === MOLAR
          ? 'molarMesialization'
          : 'canineMesialization',
      name:
        improvementType === MOLAR
          ? 'crowding.molar_mesialization'
          : 'crowding.canine_mesialization',
      options: SAGITTAL_IMPROVE_SUBOPTIONS
    }
  ];
};
